import React from 'react';
import Logo from '../../images/logo.png';
//import TALogo from '../../images/TA_Blue_300dpi.png';
import TALogo from '../../images/TALOGO.png';

const logo = (props) => (
    <span style={{ marginRight: '15px' }} ><img style={{ width: '200px', marginTop: '10px', marginLeft: '28px' }} src={TALogo} />
    </span>

);
export default logo;


// WEBPACK FOOTER //
// ./src/components/Logo/logoHeader.js